import React, { useMemo } from "react";
import { BookingPage } from '@hometown/react-hometown-lib';
import { createAddressEvent, trackProCardsViews } from "../../helpers/helpers";

const BookingPageComponent = ({ proId, formSubmitData, googlePlaceAutocompleteApiKey, serviceSeekerCallback, defaultFilters, defaultServices, isBack, serviceId, gatsbyKey, templateName, profileData, callBy, defaultDumpsterSize, limitPerPage, setIsVisible }) => {
    return (
        useMemo(() => 
        <div id="service-seeker">
            <BookingPage
                key='service-seeker'
                baseServiceId="62a9f2cd61706a135071a7e3"
                proId={proId}
                initialValues={[
                    { key: 'wasteType', value: [+formSubmitData.wasteType] },
                    { key: 'deliveryAddress', value: (formSubmitData.odf_street && formSubmitData.odf_street2) ? formSubmitData.odf_street + ', ' + formSubmitData.odf_street2 : ''},
                    { key: 'fullFormData', value: formSubmitData}
                ]}
                zipcode={formSubmitData.odf_postal_code}
                googlePlaceAutocompleteApiKey={googlePlaceAutocompleteApiKey}
                placesApiUrl= {`${process.env.GATSBY_DRUPAL_API_MANAGMENT}`}
                servicesApiUrl= {`${process.env.GATSBY_BOOKABLE_SEARCH_API}`}
                imageStaticEnv={`${process.env.GATSBY_SITE_DOMAIN}/assets/`}
                serviceCardCallback={serviceSeekerCallback}
                defaultFilters={!isBack ? defaultFilters : []}
                defaultServices={!isBack ? defaultServices : []}
                defaultService={serviceId}
                gatsbyKey={gatsbyKey}
                apolloURL={`${process.env.GATSBY_BOOKABLE_SERVICE_API}`}
                defaultTemplateName={templateName ? templateName : 'card-list'}
                profileData={profileData}
                callBy={callBy}
                defaultDumpsterSize={defaultDumpsterSize}
                limitPerPage={limitPerPage}
                setIsVisible={setIsVisible}
                trackProCardsViews={trackProCardsViews}
                createAddressEvent={createAddressEvent}
            />
        </div>, [formSubmitData]
        )
    )
}

export default BookingPageComponent;
